import { render, staticRenderFns } from "./customerCenter.vue?vue&type=template&id=791088a5&"
import script from "./customerCenter.vue?vue&type=script&lang=js&"
export * from "./customerCenter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports